export default __webpack_public_path__ + "static/mob01-c9797bde0e90d03a716451f8b162499b.png";